import "./Header.css";
import logo from "./logos/benibuy3.png";
import React from 'react';


const Header = () => {
    return (
        <header className="header">
            <div className="logo">
                <a href="https://joyabuy.com/register/?ref=300258026"
                   target="_blank"
                   rel="noopener noreferrer">
                    <img src={logo} alt="Logo" />
                </a>
            </div>
        </header>
    );
};

export default Header;
